import UsernameSelect from './UsernameSelect';
import withModal from '../../../../components/global/modal/withModal';

export const USERNAME_SELECT_MODAL = 'modal/USERNAME_SELECT';

export default withModal(UsernameSelect, {
  name: USERNAME_SELECT_MODAL,
  contentLabel: 'Select your username',
  size: 'sm',
});
